import { RanaLoading } from "../../lib/components/rana-loading";

import { RanaAuthorisationBackground } from "./rana-authorisation-background";

export const AuthLoader = () => (
  <RanaAuthorisationBackground pageSubTitle={undefined}>
    <RanaLoading h="vh" isCentered />
  </RanaAuthorisationBackground>
);
